import React, { useState, useEffect } from 'react'
import { useTransition, animated } from 'react-spring'
import SvgIcon from '../svg-icon'
import { objectModalAnimations } from '../animations'
import BgStar from './bg-star.svg'
import './object-modal.css'
 
const ObjectModal = ({params, theme, onClosed, textStyle}) => {
  const [isOpen, setIsOpen] = useState(false)

  const animationStyle = objectModalAnimations.getAnimationStyle(theme.styles.animations ? theme.styles.animations.objectModal : null)
  const decorator = theme.styles.animations ? theme.styles.animations.objectModalDecorator : null

  const transition = useTransition(isOpen, null, {
    ...animationStyle,
    onRest: () => {
      if (params && !isOpen) {
        onClosed()
      }
    }
  })

  useEffect(() => {
    if (params) {
      setIsOpen(true)
      const timer = setTimeout(() => {
        setIsOpen(false)
      }, 2000)
      return () => clearTimeout(timer)
    }
  }, [params])

  const skipAnimation = () => {
    setIsOpen(false)
  }
 
  const getIcon = () => {
    let icon = params.asset ? params.asset.icon : null
    return icon ? <SvgIcon className="modal-icon" icon={icon} style={{ fill: theme.styles.sequenceText,  stroke: theme.styles.sequenceText }} /> : null
  }

  return params && (
    <div className="object-modal-container" style={{ fontFamily: theme.styles.fontFamily, ...textStyle }} onClick={skipAnimation}>
      {transition.map(
        ({ item, key, props }) => (
          item && (
            <animated.div key={key} style={props} className="object-modal-wrapper">
              <div className="object-modal" style={{ background: theme.styles.sequenceBackground }}>
                { getIcon() }
                { params.asset && params.asset.desc && (
                  <div className="object-modal-label" style={{ marginTop: '.5em', color: theme.styles.sequenceText }}>{params.asset.desc}</div>
                )}
              </div>
            </animated.div>
          )
        )
      )}
      { decorator === "star" && (
        <SvgIcon className="object-modal-star" icon={BgStar} style={{ fill: theme.styles.animations.objectModalDecoratorColor || '#FCEE21' }} />
      )}
    </div>
  )
}

export default ObjectModal